import type { ListDataParams } from '../types';
import type {
  CampaignMessageParams,
  CampaignMetricsParams,
  CampaignRecipientsParams
} from '@/interfaces/Campaign.interface';

export type CampaignsListQueryParams = {
  listData: ListDataParams;
};

export type CampaignMetricsQueryParams = {
  uuid: string;
} & CampaignMetricsParams;

export type CampaignMessageQueryParams = {
  uuid: string;
} & CampaignMessageParams;

export type CampaignRecipientsQueryParams = {
  uuid: string;
  listData: ListDataParams;
  searchTerm?: string;
} & CampaignRecipientsParams;

export const campaignsQueryKeys = {
  all: ['campaigns'] as const,
  lists: () => [...campaignsQueryKeys.all, 'list'] as const,
  list: (params: CampaignsListQueryParams) =>
    [...campaignsQueryKeys.lists(), params] as const,
  details: () => [...campaignsQueryKeys.all, 'detail'] as const,
  detail: (uuid: string) => [...campaignsQueryKeys.details(), uuid] as const,
  launchReadiness: (uuid: string) =>
    [...campaignsQueryKeys.all, 'launch-readiness', uuid] as const,
  metrics: (params: CampaignMetricsQueryParams) =>
    [...campaignsQueryKeys.all, 'metrics', params] as const,
  metricsByCampaign: (uuid: string) =>
    [...campaignsQueryKeys.all, 'metrics', { uuid }] as const,
  message: (params: CampaignMessageQueryParams) =>
    [...campaignsQueryKeys.all, 'message', params] as const,
  recipients: (params: CampaignRecipientsQueryParams) =>
    [...campaignsQueryKeys.all, 'recipients', params] as const
};
